export const hasUnreliableDownloads = ({ isWebKit, }) => isWebKit;
